













import { defineComponent, reactive } from '@vue/composition-api';
import { SelectOption } from '../types';
import { OlbFlyoutSelect } from '../../form';

export default defineComponent({
	components: {
		OlbFlyoutSelect,
	},
	props: {
		sortOptions: {
			type: Array as () => SelectOption[],
			required: true,
		},
		sortUrl: {
			type: String,
		},
	},
	setup(props) {
		const state = reactive({
			sort: props.sortOptions.find((option) => option.selected === true)?.value || props.sortOptions[0].value,
		});
		function onInput() {
			document.location.href = `${props.sortUrl}${state.sort}`;
		}
		return { state, onInput };
	},
});
